import { useMemo } from 'react'
import { useDebugPacksOverride } from 'src/features/UAPromotion/debug/store'
import { useListExtraPackages } from 'src/services/orpc/extraPackage'
import { useCurrency } from 'src/utils/currency'
import { adaptOrpcSkusToExtraPackages } from './adapter'
import type { ExtraPackage, ExtraPackagePromotionOption } from './types'

interface UseExtraPackagesArgs {
  /** User's current membership tier — drives `extraPackageBoosts`. Pass `undefined` for tier-0 boosts. */
  currentTier: number | undefined
  /** Coupon code wrapper. Pass `null` to defer the query (e.g. while waiting for the coupon list). */
  promotionOption: ExtraPackagePromotionOption | null
}

export function useExtraPackages(
  args: UseExtraPackagesArgs,
): ExtraPackage[] | undefined {
  const { currentTier, promotionOption } = args
  const [currency, , currencyReady] = useCurrency()
  const enabled = promotionOption !== null && currencyReady

  const query = useListExtraPackages({
    currency,
    promotionOption: promotionOption ?? undefined,
    enabled,
  })

  const real = useMemo(
    () => adaptOrpcSkusToExtraPackages(query.data, currentTier),
    [query.data, currentTier],
  )
  const debugPacks = useDebugPacksOverride()
  return debugPacks ?? real
}
